<script setup lang="ts">
    import { defineAsyncComponent } from 'vue';
    import TopBannerLeft from '../components/oferta/TopBannerLeft.vue' 
    import FormarBloque from '../components/oferta/FormarBloqueNeo.vue'; 
    const MtrPlanEstudios = defineAsyncComponent(() => import('../components/oferta/MtrPlanEstudios.vue')) ; 
    const VerModelo = defineAsyncComponent(() => import('../components/oferta/VerModelo.vue')) ;
const PoliticaIA = defineAsyncComponent(() => import('../components/oferta/PoliticaIA.vue'))
    const CalendarioOferta = defineAsyncComponent(() => import('../components/oferta/CalendarioOferta.vue'))
    // const DescargaFolleto = defineAsyncComponent(() => import('../components/oferta/DescargaFolleto.vue')) ; 
    // const MtrModEjec = defineAsyncComponent(() => import('../components/oferta/MtrModEjec.vue')) ; 
    // const EgresadosHuma = defineAsyncComponent(() => import('../components/oferta/EgresadosHuma.vue')) ;

</script>

<template>
    <TopBannerLeft
        :img="'background-image: url(../../pagesImages/banner-corpo1.jpg);'"
        :nivel="'Maestr&iacute;a en'"
        :carrera="'Derecho'"
        :complemento="'Empresarial Corporativo'"
        :frase="'La paz y la justicia son dos lados de la misma moneda'"
        :autor="'Dwight D. Eisenhower'"
    />

    <FormarBloque
        :img="'../../pagesImages/student3.jpg'"
        :link="'/requisitos-maestria'"
        :frase="'Especializados en la dirección general de empresas, capaces de comprender e involucrarse activamente en las problemáticas más complejas'"
        alt="Estudiante de Maestría en Derecho Empresarial Corporativo"
        :testo1="'La Maestría en Derecho Corporativo integra materias clave para una formación especializada en el ámbito legal-empresarial. Este enfoque permite una comprensión profunda de las normativas y estrategias jurídicas aplicables al entorno corporativo, fiscal, aduanero y laboral.'"
        :testo3="'Los aspirantes a esta Maestría son profesionistas con interés en fortalecer su formación en Derecho Corporativo y normativas empresariales. Se espera que posean habilidades analíticas, capacidad de negociación y un enfoque estratégico en la asesoría legal para empresas.'"
    />

    <div class="flex items-center justify-center my-10">
    </div>

    <MtrPlanEstudios
        :ejecutivo="true"
        :virtual="true"
    />

    

    <VerModelo esco=""
    ejec="/pagesImages/Programas/Maestria/Plan_De_Estudios_Derecho-Empresarial_Web.webp,/pagesImages/Programas/Maestria/Plan_De_Estudios_Derecho-Empresarial_Cel.webp"
    virt="/pagesImages/Programas/Maestria/Plan_De_Estudios_Derecho-Empresarial_Web.webp,/pagesImages/Programas/Maestria/Plan_De_Estudios_Derecho-Empresarial_Cel.webp"
    :escoT="false"
    :ejecT="true"
    :virtT="true" />

    <CalendarioOferta nombre="Maestría en Derecho Empresarial Corporativo" 
  :inicios="[true, true, false, true, false, true, false, true]"></CalendarioOferta>

    <!-- <VerModelo esco=""
    ejec="/pagesImages/Programas/Maestria-ant/maestria-derecho-empresarial-ejecutivo.webp"
    virt="/pagesImages/Programas/Maestria-ant/maestria-derecho-empresarial-ejecutivo.webp"
    :escoT="false"
    :ejecT="true"
    :virtT="true" /> -->

    <section class="flex items-center justify-center mb-16 w-full">
		<div class="lg:flex flex-col lg:px-4 px-8 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between">
				<div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                        <h2>
                            <span class="block font-serif text-[42px] text-hgold text-left" style="">Estructura académica</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-xl text-left mb-3">(Bloques trimestrales):</span>
                        </h2>
                        <ul class="list-disc pl-5 mb-4">
                            <li><b>Bloque Corporativo:</b> Legislación mercantil, gobierno corporativo y estrategias legales empresariales.</li>
                            <li><b>Bloque Fiscal:</b> Normatividad tributaria, planeación fiscal y cumplimiento de obligaciones fiscales.</li>
                            <li><b>Bloque Aduanero:</b> Regulación del comercio exterior, tratados internacionales y procedimientos aduaneros.</li>
                            <li><b>Bloque de Propiedad Intelectual:</b> Protección de marcas y patentes, derechos de autor y litigios en propiedad intelectual.</li>
                            <li><b>Bloque Laboral y Seguridad Social:</b> Legislación laboral, relaciones colectivas e individuales de trabajo y normativas de seguridad social.</li>
                            <li><b>Seminario de titulación:</b> Desarrollo de un proyecto aplicado para la obtención del grado.</li>
                            <!-- <li><b>Seminario de Inteligencia Artificial.</b> Conocimiento, comprensión y aplicación de las herramientas de Inteligencia Artificial en entornos académicos, profesionales y laborales, fortaleciendo las habilidades y capacidades.</li> -->
                        </ul>
                        <p>
                            Este programa está diseñado para formar especialistas en Contabilidad con una visión estratégica, capaces de responder a los desafíos del entorno fiscal, financiero y corporativo con un enfoque integral y actualizado.
                        </p>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/hombre-mujer-maestria-estructura.webp" alt="Alt pendiente" class="w-full lg:max-w-[520px]"/>
					</div>
                </div>
			</div>
		</div>
	</section>

    <!-- <MtrModEjec class="mb-16" />

    <section class="flex items-center justify-center mb-16 w-full">
		<div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between">
				<div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                        <h2>
                            <span class="block text-hgold text-left font-serif mb-3 text-[42px]">Metodología</span>
                        </h2>
                        <p class="mb-4">
                            El modelo ejecutivo se desarrolla bajo la siguiente estructura:
                        </p>
                        <ul class="list-disc pl-5 mb-4">
                            <li>Consta de 6 bloques trimestrales.</li>
                            <li>Cada bloque equivale a tres materias fusionadas, impartidas por un especialista en la materia.</li>
                            <li>Se imparten clases un día a la semana, tres horas de clases presenciales.</li>
                            <li>El modelo educativo tiene una duración de diez semanas de clases, y una semana adicional culminando con una evaluación final.</li>
                            <li>La evaluación se compone de participación en clase, foros, trabajos y examen final, integrando así un proceso de aprendizaje integral.</li>
                        </ul>
                        <p>
                            Este modelo permite a los estudiantes desarrollar habilidades especializadas con un enfoque práctico y estratégico, alineado con las exigencias del mundo profesional actual.
                        </p>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/universidad-fisica-virtual.webp" alt="Estudiantes de maestría en alta dirección corporativa universidad Humanitas" class="w-full lg:max-w-[520px]"/>
					</div>
                </div>
			</div>
		</div>
	</section> -->
    
    <section class="lg:flex items-center justify-center bg-cover bg-[center] bg-no-repeat mb-16" style="background-image: url(/pagesImages/madin3.jpg); position: relative; background-attachment: fixed; background-position: left; background-repeat: no-repeat; background-size: cover; overflow: hidden; transition: transform 0.3s ease;">
        <div class="lg:flex items-center justify-center w-full h-full my-16">
            <div class="lg:flex items-center justify-between w-full max-w-[1200px]">
                <img src="/pagesImages/perfil-egresado-maestrias.webp" alt="Egresados de maestría de Derecho Empresarial Corporativo" class="lg:p-0 w-full lg:max-w-[520px] md:px-16 px-6 pt-6"/>
                <div class="flex flex-col lg:justify-start justify-center items-center lg:items-start lg:w-[50%] w-full lg:my-24 py-12 text-justify lg:px-0  px-8">
                    <h2>
                        <span class="block text-[28px] text-hwine leading-none text-center md:text-left">Perfil del egresado de la maestría en</span>
                        <span class="sr-only whitespace-nowrap">&nbsp;</span>
                        <span class="block text-hwine text-[42px] mb-4 leading-tight text-center md:text-left font-serif ">Derecho Empresarial Corporativo</span>
                    </h2>
                    <p class="text-justify text-gray-800 lg:hyphens-manual hyphens-auto">Este programa les permitirá desarrollar competencias en regulación mercantil, fiscal, aduanera y laboral, brindándoles herramientas para la toma de decisiones estratégicas en el ámbito jurídico empresarial.</p>
                    <br>
                    <router-link to="/contacto">
                        <div class="flex items-center justify-center w-[140px] h-[35px] hover:bg-hwine bg-hgold text-white  text-lg transition duration-300 ease-in-out">
                            <span>Inscr&iacute;bete</span>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </section>

    <section class="flex items-center justify-center mb-16 w-full">
		<div class="lg:flex flex-col lg:px-4 px-8 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between w-full">
				<div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                        <h2>
                            <span class="block leading-none text-left text-[28px]" style="">Cinco razones para elegir</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-hgold text-left font-serif mb-3 text-[42px]">Universidad Humanitas:</span>
                        </h2>
                        <ul class="list-disc pl-5 mb-4">
                            <li>Modelo educativo especializado.</li>
                            <li>Excelencia académica.</li>
                            <li>Instalaciones de primer nivel.</li>
                            <li>Costos accesibles.</li>
                            <li>Acreditaciones reconocidas (SEP, ESR y GPTW).</li>
                        </ul>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/beneficios-estudiar-universidad-humanitas.webp" alt="Beneficios de estudiar en Universidad Humanitas" class="w-full lg:max-w-[520px]"/>
					</div>
                </div>
			</div>
		</div>
	</section>
    <PoliticaIA />
</template>

<style scoped>
</style>